import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./brand.css";
import { installErrorReporter } from "./errorReporter";
import { rememberCampaign } from "../shared/campaign";

installErrorReporter();
// A campaign link (utm_* or ref) that opens the app is remembered for this tab, so a family that signs up
// from it is counted by source. First-party only: sessionStorage, sent with /api/signup, nothing else.
rememberCampaign(window.location.search);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
